import { API } from "@aws-amplify/api";

export const deleteSignQuery = `query($input:deleteBolSignatureInput) {
    deleteBolSignature(input: $input) {
    fileName
    getUrl
    putUrl
    sequence
    }
    }`;

export async function deleteSign(params: any): Promise<any> {
    try {
        return API.graphql({
            query: deleteSignQuery, variables: {
                input: params
            }
        })
    } catch (error) {
        console.log("Delete Sign", error);
    }
}
